import classNames from 'classnames';
import { components } from 'react-select';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  iconSelect: {
    width: 72,
  },
}));

const SelectContainer = props => {
  const classes = useStyles();
  const { isIcon, selectContainerClass } = props.selectProps;

  return (
    <components.SelectContainer
      {...props}
      className={classNames(
        { [classes.iconSelect]: isIcon },
        selectContainerClass
      )}
    >
      {props.children}
    </components.SelectContainer>
  );
};

export default SelectContainer;
